import script from "./StandardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardCard.vue?vue&type=script&setup=true&lang=js"

import "./StandardCard.vue?vue&type=style&index=0&id=1c98a12b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c98a12b"]])

export default __exports__